// extracted by mini-css-extract-plugin
export var header = "_hi-0";